export const iconFontAwesomeLogisticsBridgeCircleXmark = (
	<i className="fa-solid fa-bridge-circle-xmark"></i>
);
